export type CanalTipo = 'chat' | 'whatsapp' | 'email' | 'ticket';

export interface ConversaCanal {
  id: string;
  canal: CanalTipo;
  usuario_nome: string;
  usuario_email: string;
  usuario_tipo: 'empresa' | 'participante';
  usuario_telefone?: string;
  titulo: string;
  status: 'aberto' | 'em_andamento' | 'aguardando' | 'resolvido' | 'fechado';
  prioridade: 'baixa' | 'media' | 'alta' | 'urgente';
  responsavel: string;
  ticket_id?: string; // null = ainda não virou ticket
  origem_manual?: string; // canal de origem do ticket manual (ex: Telefone, Presencial)
  data_criacao: string;
  data_atualizacao: string;
  respostas: RespostaConversa[];
}

export interface RespostaConversa {
  id: string;
  autor_nome: string;
  autor_role: string;
  canal_origem: CanalTipo; // de onde veio a msg (ex: user respondeu por whatsapp, operador por chat)
  mensagem: string;
  data: string;
  interna: boolean;
}

export const conversasCanais: ConversaCanal[] = [
  {
    id: 'CH-2026-0015',
    canal: 'chat',
    usuario_nome: 'João Pedro Silva',
    usuario_email: 'joao.silva@email.com',
    usuario_tipo: 'participante',
    usuario_telefone: '(11) 98765-4321',
    titulo: 'Não consigo resgatar meus pontos para PIX',
    status: 'aberto',
    prioridade: 'alta',
    responsavel: 'Ana Souza',
    ticket_id: 'TK-2026-0042',
    data_criacao: '2026-05-08T09:15:00Z',
    data_atualizacao: '2026-05-08T09:15:00Z',
    respostas: [],
  },
  {
    id: 'WA-2026-0010',
    canal: 'whatsapp',
    usuario_nome: 'Ricardo Ferreira',
    usuario_email: 'ricardo@inovacaodigital.com.br',
    usuario_tipo: 'empresa',
    usuario_telefone: '(31) 99876-5432',
    titulo: 'Empresa não aparece na lista de campanhas',
    status: 'em_andamento',
    prioridade: 'media',
    responsavel: 'Ana Souza',
    ticket_id: undefined,
    data_criacao: '2026-05-07T14:30:00Z',
    data_atualizacao: '2026-05-08T10:00:00Z',
    respostas: [
      {
        id: 'r-wa-001',
        autor_nome: 'Ricardo Ferreira',
        autor_role: 'empresa',
        canal_origem: 'whatsapp',
        mensagem: 'Olá! Cadastrei minha empresa ontem e ainda não consigo acessar o painel de campanhas. O CNPJ é 45.678.901/0001-23.',
        data: '2026-05-07T14:30:00Z',
        interna: false,
      },
      {
        id: 'r-wa-002',
        autor_nome: 'Ana Souza',
        autor_role: 'suporte',
        canal_origem: 'chat',
        mensagem: 'Oi Ricardo! Verificamos aqui que o cadastro está pendente de aprovação. Já fizemos a liberação e você já pode acessar o painel. Pode tentar agora?',
        data: '2026-05-08T10:00:00Z',
        interna: false,
      },
    ],
  },
  {
    id: 'EM-2026-0008',
    canal: 'email',
    usuario_nome: 'Fernanda Costa',
    usuario_email: 'fernanda@techbrasil.com.br',
    usuario_tipo: 'empresa',
    usuario_telefone: '(21) 96543-2109',
    titulo: 'Pontuação não creditou após venda',
    status: 'em_andamento',
    prioridade: 'media',
    responsavel: 'Mariana Lima',
    ticket_id: undefined,
    data_criacao: '2026-05-06T16:45:00Z',
    data_atualizacao: '2026-05-07T11:21:00Z',
    respostas: [
      {
        id: 'r-em-001',
        autor_nome: 'Fernanda Costa',
        autor_role: 'empresa',
        canal_origem: 'email',
        mensagem: 'Prezados, realizei uma venda de R$ 2.800,00 no dia 05/05 mas os pontos ainda não apareceram no extrato do colaborador. Solicito verificação.',
        data: '2026-05-06T16:45:00Z',
        interna: false,
      },
      {
        id: 'r-em-002',
        autor_nome: 'Mariana Lima',
        autor_role: 'operador',
        canal_origem: 'chat',
        mensagem: 'Olá Fernanda! Estamos verificando a conciliação da venda. Poderia nos enviar o número do pedido?',
        data: '2026-05-07T11:20:00Z',
        interna: false,
      },
      {
        id: 'r-em-003',
        autor_nome: 'Mariana Lima',
        autor_role: 'operador',
        canal_origem: 'chat',
        mensagem: 'Nota interna: verificar integração com webhook de vendas. Parece que o evento não foi disparado corretamente.',
        data: '2026-05-07T11:21:00Z',
        interna: true,
      },
    ],
  },
  {
    id: 'TK-2026-0041',
    canal: 'ticket',
    usuario_nome: 'Paulo Henrique',
    usuario_email: 'paulo@sistemasintegrados.com.br',
    usuario_tipo: 'empresa',
    usuario_telefone: '(41) 95432-1098',
    titulo: 'Solicitação de reembolso de compra de pontos',
    status: 'aberto',
    prioridade: 'urgente',
    responsavel: 'Carlos Mendes',
    ticket_id: 'TK-2026-0041',
    data_criacao: '2026-05-08T08:00:00Z',
    data_atualizacao: '2026-05-08T08:00:00Z',
    respostas: [],
  },
  {
    id: 'WA-2026-0009',
    canal: 'whatsapp',
    usuario_nome: 'Beatriz Santos',
    usuario_email: 'bia.santos@email.com',
    usuario_tipo: 'participante',
    usuario_telefone: '(51) 94321-0987',
    titulo: 'Problema no login do aplicativo',
    status: 'resolvido',
    prioridade: 'alta',
    responsavel: 'Ana Souza',
    ticket_id: 'TK-2026-0038',
    data_criacao: '2026-05-05T11:10:00Z',
    data_atualizacao: '2026-05-06T15:30:00Z',
    respostas: [
      {
        id: 'r-wa-004',
        autor_nome: 'Beatriz Santos',
        autor_role: 'participante',
        canal_origem: 'whatsapp',
        mensagem: 'Oi! O app trava na tela de login após digitar email e senha. Já reinstalei e o problema persiste. Estou usando iPhone 15.',
        data: '2026-05-05T11:10:00Z',
        interna: false,
      },
      {
        id: 'r-wa-005',
        autor_nome: 'Ana Souza',
        autor_role: 'suporte',
        canal_origem: 'chat',
        mensagem: 'Oi Beatriz! Identificamos um bug na última versão do app. Fizemos uma correção e liberação da versão 2.4.1. Por favor atualize e tente novamente.',
        data: '2026-05-06T15:30:00Z',
        interna: false,
      },
    ],
  },
  {
    id: 'EM-2026-0007',
    canal: 'email',
    usuario_nome: 'Luciana Almeida',
    usuario_email: 'luciana@empresaexemplo.com.br',
    usuario_tipo: 'empresa',
    usuario_telefone: '(71) 93210-9876',
    titulo: 'Dúvida sobre regras de pontuação',
    status: 'fechado',
    prioridade: 'baixa',
    responsavel: 'Mariana Lima',
    ticket_id: 'TK-2026-0037',
    data_criacao: '2026-05-03T09:00:00Z',
    data_atualizacao: '2026-05-04T14:00:00Z',
    respostas: [
      {
        id: 'r-em-004',
        autor_nome: 'Luciana Almeida',
        autor_role: 'empresa',
        canal_origem: 'email',
        mensagem: 'Bom dia! Gostaria de entender melhor como funciona a pontuação por meta atingida vs pontuação por vendas diretas.',
        data: '2026-05-03T09:00:00Z',
        interna: false,
      },
      {
        id: 'r-em-005',
        autor_nome: 'Mariana Lima',
        autor_role: 'operador',
        canal_origem: 'chat',
        mensagem: 'Bom dia Luciana! Enviei um material completo sobre as regras de pontuação no seu email. Também disponibilizamos na área de treinamento do portal.',
        data: '2026-05-04T14:00:00Z',
        interna: false,
      },
    ],
  },
  {
    id: 'CH-2026-0014',
    canal: 'chat',
    usuario_nome: 'Roberto Dias',
    usuario_email: 'roberto.dias@email.com',
    usuario_tipo: 'participante',
    usuario_telefone: '(61) 92109-8765',
    titulo: 'Saque PIX atrasado há 3 dias',
    status: 'aberto',
    prioridade: 'urgente',
    responsavel: 'Carlos Mendes',
    ticket_id: undefined,
    data_criacao: '2026-05-08T07:30:00Z',
    data_atualizacao: '2026-05-08T07:30:00Z',
    respostas: [
      {
        id: 'r-ch-001',
        autor_nome: 'Roberto Dias',
        autor_role: 'participante',
        canal_origem: 'chat',
        mensagem: 'Solicitei resgate de R$ 450,00 no dia 02/05 e ainda não recebi na minha conta. Isso já faz 3 dias.',
        data: '2026-05-08T07:30:00Z',
        interna: false,
      },
    ],
  },
  {
    id: 'WA-2026-0011',
    canal: 'whatsapp',
    usuario_nome: 'Amanda Rocha',
    usuario_email: 'amanda@consultoratech.com.br',
    usuario_tipo: 'empresa',
    usuario_telefone: '(27) 90987-6543',
    titulo: 'Erro ao gerar relatório de performance',
    status: 'em_andamento',
    prioridade: 'alta',
    responsavel: 'Ana Souza',
    ticket_id: undefined,
    data_criacao: '2026-05-07T10:20:00Z',
    data_atualizacao: '2026-05-08T09:00:00Z',
    respostas: [
      {
        id: 'r-wa-006',
        autor_nome: 'Amanda Rocha',
        autor_role: 'empresa',
        canal_origem: 'whatsapp',
        mensagem: 'Oi! Ao clicar em "Exportar Relatório" recebo erro 500. Acontece com todos os relatórios. Preciso urgentemente dos dados de performance da minha equipe.',
        data: '2026-05-07T10:20:00Z',
        interna: false,
      },
      {
        id: 'r-wa-007',
        autor_nome: 'Ana Souza',
        autor_role: 'suporte',
        canal_origem: 'chat',
        mensagem: 'Oi Amanda! Estamos investigando o problema no servidor de relatórios. Identificamos uma instabilidade que está sendo corrigida agora. Deve voltar em breve.',
        data: '2026-05-08T09:00:00Z',
        interna: false,
      },
    ],
  },
  {
    id: 'CH-2026-0013',
    canal: 'chat',
    usuario_nome: 'Marcos Oliveira',
    usuario_email: 'marcos.oliveira@email.com',
    usuario_tipo: 'participante',
    usuario_telefone: '(13) 98765-1234',
    titulo: 'Dúvida sobre transferência de pontos',
    status: 'aberto',
    prioridade: 'baixa',
    responsavel: 'Mariana Lima',
    ticket_id: undefined,
    data_criacao: '2026-05-08T10:00:00Z',
    data_atualizacao: '2026-05-08T10:00:00Z',
    respostas: [
      {
        id: 'r-ch-002',
        autor_nome: 'Marcos Oliveira',
        autor_role: 'participante',
        canal_origem: 'chat',
        mensagem: 'Posso transferir meus pontos para outro participante da mesma empresa?',
        data: '2026-05-08T10:00:00Z',
        interna: false,
      },
    ],
  },
  {
    id: 'EM-2026-0009',
    canal: 'email',
    usuario_nome: 'Juliana Martins',
    usuario_email: 'juliana@getpoints.com.br',
    usuario_tipo: 'empresa',
    usuario_telefone: '(48) 99654-3210',
    titulo: 'Campanha expirou sem aviso',
    status: 'aberto',
    prioridade: 'alta',
    responsavel: 'Carlos Mendes',
    ticket_id: 'TK-2026-0043',
    data_criacao: '2026-05-08T06:00:00Z',
    data_atualizacao: '2026-05-08T06:00:00Z',
    respostas: [],
  },
];

// Canal config
export const canalConfig: Record<CanalTipo, { icon: string; label: string; color: string; bg: string }> = {
  chat: { icon: 'ri-chat-1-line', label: 'Chat', color: 'text-blue-600', bg: 'bg-blue-50' },
  whatsapp: { icon: 'ri-whatsapp-line', label: 'WhatsApp', color: 'text-emerald-600', bg: 'bg-emerald-50' },
  email: { icon: 'ri-mail-line', label: 'Email', color: 'text-amber-600', bg: 'bg-amber-50' },
  ticket: { icon: 'ri-ticket-line', label: 'Ticket', color: 'text-gray-600', bg: 'bg-gray-50' },
};

export let conversasData = [...conversasCanais];

export function getConversas(): ConversaCanal[] {
  return conversasData;
}

export function getConversaById(id: string): ConversaCanal | undefined {
  return conversasData.find((c) => c.id === id);
}

export function getConversasPorCanal(canal: CanalTipo): ConversaCanal[] {
  return conversasData.filter((c) => c.canal === canal);
}

export function atualizarStatusConversa(id: string, novoStatus: ConversaCanal['status']): boolean {
  const idx = conversasData.findIndex((c) => c.id === id);
  if (idx === -1) return false;
  conversasData[idx] = {
    ...conversasData[idx],
    status: novoStatus,
    data_atualizacao: new Date().toISOString(),
  };
  return true;
}

export function atribuirResponsavelConversa(id: string, responsavel: string): boolean {
  const idx = conversasData.findIndex((c) => c.id === id);
  if (idx === -1) return false;
  conversasData[idx] = {
    ...conversasData[idx],
    responsavel,
    data_atualizacao: new Date().toISOString(),
  };
  return true;
}

export function adicionarRespostaConversa(
  id: string,
  resposta: Omit<RespostaConversa, 'id' | 'data'>,
): boolean {
  const idx = conversasData.findIndex((c) => c.id === id);
  if (idx === -1) return false;
  const novaResposta: RespostaConversa = {
    id: `r-${Date.now()}`,
    ...resposta,
    data: new Date().toISOString(),
  };
  conversasData[idx] = {
    ...conversasData[idx],
    respostas: [...conversasData[idx].respostas, novaResposta],
    data_atualizacao: new Date().toISOString(),
  };
  return true;
}

export function vincularTicketConversa(id: string, ticketId: string): boolean {
  const idx = conversasData.findIndex((c) => c.id === id);
  if (idx === -1) return false;
  conversasData[idx] = {
    ...conversasData[idx],
    ticket_id: ticketId,
    data_atualizacao: new Date().toISOString(),
  };
  return true;
}

export function resetConversas(): void {
  conversasData = [...conversasCanais];
}